import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-white border-t border-slate-100" data-id="element-1">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-4">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight text-navy" data-id="element-5">
              Building Teams Through{' '}
              <span className="text-gradient" data-id="element-6">Meaningful Partnerships</span>
            </h2>

            <div className="space-y-6 text-lg text-slate-600" data-id="element-7">
              <p data-id="element-8">
                At TALVORI, we believe exceptional hiring starts with genuine
                partnership.
              </p>
              <p data-id="element-9">
                With over 10 years of combined experience in talent acquisition
                and people operations, we've helped startups, agencies, and
                growing businesses build high-performing teams across
                industries. We go beyond recruiting by taking the time to
                understand your business, culture, and growth strategy. As
                trusted talent partners, our goal is to connect you with
                professionals who not only meet the requirements of the role,
                but also contribute to your organization's long-term success.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="grid sm:grid-cols-2 gap-6" data-id="element-10">
            {/* Founder 1 */}
            <div className="bg-slate-50 rounded-3xl p-6 border border-slate-100 hover:shadow-soft-lg transition-shadow" data-id="element-11">
              <div className="aspect-square rounded-2xl bg-brand-gradient-soft mb-6 relative overflow-hidden ring-4 ring-pink ring-offset-2 ring-offset-slate-50" data-id="element-12">
                <img src="https://cdn.magicpatterns.com/uploads/3Q2pFbCk9pNVHntQMjQJDK/WhatsApp_Image_2026-05-29_at_21.38.56.jpg" alt="Tanya Alfaro, Co-Founder & Talent Partner" className="absolute inset-0 w-full h-full object-cover" data-id="element-13" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-1" data-id="element-14">Tanya Alfaro</h3>
              <p className="text-sm font-medium text-slate-500" data-id="element-15">
                Co-Founder & Talent Partner
              </p>
            </div>

            {/* Founder 2 */}
            <div className="bg-slate-50 rounded-3xl p-6 border border-slate-100 hover:shadow-soft-lg transition-shadow sm:translate-y-8" data-id="element-16">
              <div className="aspect-square rounded-2xl bg-brand-gradient-soft mb-6 relative overflow-hidden ring-4 ring-navy ring-offset-2 ring-offset-slate-50" data-id="element-17">
                <img src="https://cdn.magicpatterns.com/uploads/8TCHuRKe42uCkDG9AaiMuK/WhatsApp_Image_2026-06-02_at_18.55.42.jpg" alt="Orianna Duran, Co-Founder & Talent Partner" className="absolute inset-0 w-full h-full object-cover" data-id="element-18" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-1" data-id="element-19">
                Orianna Duran
              </h3>
              <p className="text-sm font-medium text-slate-500" data-id="element-20">
                Co-Founder & Talent Partner
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}